import ChartStatisticsInOut from "./TLVmuniContainer/ChartStatisticsInOut";
// import BarChartWeeklyStatistics from "./ChartVehicles/BarChartWeklyStatistics";
import React from "react";

import StatisticMap from "./TLVmuniContainer/StatisticMap";
import CreativeReport from "./TLVmuniContainer/CreativeReports";
import ColorPallette from "./TLVmuniContainer/ColorsPallette";
import useConfig from "../../hooks/useConfig";
import useAuth from "../../hooks/authenticate/useAuth";

const TLVmuniContainer = () => {
  const { config } = useConfig();
  const { auth } = useAuth();
  return (
    <div className="w-full h-full flex flex-col items-center justify-center p-10 shadow-xl  backdrop-blur-xl  bg-blue-900 bg-opacity-30  rounded-xl ">
      <div className="w-full h-full flex flex-col items-center ">
        <div className=" w-full h-1/2  px-8 py-5">
          <ChartStatisticsInOut />
        </div>
        <div className=" h-full w-full flex flex-row justify-center px-7  ">
          <div className="px-8  py-5 ">
            <div className="h-full flex flex-col justify-evenly bg-white rounded-lg ">
              <div className="w-full ">
                <ColorPallette />
              </div>
              <div className="w-full flex-shrink-0 h-full">
                <StatisticMap
                  areas={config.areas}
                  token={auth.token}
                  mapConfig={config.map}
                />
              </div>
            </div>
          </div>

          <div className="w-full h-full px-8  ">
            <CreativeReport />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TLVmuniContainer;
